import { Skeleton } from '@antimatterhq/ui/components/skeleton';

// Bottom section: Two columns of horizontal skeletons
export const QueryResultsTableSkeleton = () => {
  return (
    <div className="flex gap-2 p-2">
      {/* Left column: Fixed 200px width */}
      <div className="flex w-[200px] flex-col gap-3">
        {Array.from({ length: 13 }).map((_, i) => (
          <Skeleton key={i} className="h-4 w-full rounded-sm" />
        ))}
      </div>

      {/* Right column: Takes remaining space */}
      <div className="flex flex-1 flex-col gap-3">
        {Array.from({ length: 9 }).map((_, i) => (
          <Skeleton key={i} className="h-7 w-full rounded-sm" />
        ))}
      </div>
    </div>
  );
};
